import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducer } from 'src/redux/rootReducer'
import NewButton from './NewButton'
import { OPEN_DEMO_MODAL } from 'dealer-reducers'

const TestAccessBanner = (): JSX.Element => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const isTestAccess = useSelector((state: RootReducer) => {
    const authState = state.authReducer.authorizedState
    return authState === 'authorized' && state.userDataReducer.test_access
  })
  const expirationDate = useSelector((state: RootReducer) => state.userDataReducer.demo_expires_at)

  if (!isTestAccess) {
    return <></>
  }

  const handleContactSupport = (): void => {
    window.open('mailto:partner@estigroup.de', '_blank')
  }

  const handleUpgrade = (): void => {
    dispatch(OPEN_DEMO_MODAL())
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-[1000] hidden md:block">
      <div className="px-4 py-3 flex items-center justify-between max-w-7xl mx-auto">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <div className="w-3 h-3 bg-groupBlue rounded-full animate-pulse"></div>
            <span className="text-gray-800 font-semibold text-sm">{t('test_access_banner.demo_mode')}</span>
          </div>
          {expirationDate !== '' && (
            <div className="text-gray-600 text-sm">
              {t('test_access_banner.expires_on')}: <span className="font-medium text-gray-800">{expirationDate}</span>
            </div>
          )}
        </div>
        <div className="flex items-center space-x-3">
          <NewButton buttonType="gray" buttonVariant="small" onClick={handleContactSupport}>
            {t('test_access_banner.contact_support')}
          </NewButton>
          <NewButton buttonType="blue" buttonVariant="small" onClick={handleUpgrade}>
            {t('test_access_banner.upgrade_now')}
          </NewButton>
        </div>
      </div>
    </div>
  )
}

export default TestAccessBanner
